<main class="container">

    <!-- ورود به حساب کاربری -->

    <div class="modal show bg-secondary" style="display: block;">

        <div class="modal-dialog modal-dialog-centered flex-column justify-content-center">

            <div class="modal-content">

                <div class="modal-header">

                    <h2 class="modal-title mb-0" id="exampleModalLabel">

                        {{ bLoginMode ? 'ورود به حساب کاربری' : 'ثبت نام' }}

                    </h2>

                    <button type="button" class="btn" (click)="dismissModal()">

                        <mat-icon class="mat-18">close</mat-icon>

                    </button>

                </div>

                <form [formGroup]="signUpModel" class="modal-body">

                    <div class="d-none alert alert-warning">

                        <p class="mb-0">این طرح صرفاً به‌منظور تخصیص سوخت به دارندگان مجوز صیادی معتبر صادره از سازمان
                            شیلات اجرا می‌گردد. بدیهی است ثبت‌نام افراد فاقد مجوز معتبر، هیچ‌گونه تعهدی برای سازمان
                            شیلات در خصوص تخصیص سوخت ایجاد نخواهد کرد.</p>

                    </div>

                    <h2 class=""> {{ !bSendOtp ? '' : 'کد تأیید را وارد کنید' }} </h2>

                    <!-- ثبت‌ نام یا OTP -->

                    <ng-container *ngIf="!bLoginMode">

                        <span class="">

                            {{ !bSendOtp ? '' : otpMessage | faNum}}

                            <span *ngIf="bSendOtp" id="changeNumber-btn" class="change-number" (click)="changeNumber()">

                                تغییر شماره

                            </span>

                        </span>

                    </ng-container>

                    <!-- پیام حالت لاگین -->

                    <span *ngIf="bLoginMode">

                        شماره موبایل متعلق به خودتان را وارد کنید.

                    </span>

                    <!-- فیلد موبایل -->

                    <ng-container *ngIf="isLoginMode">

                        <div class="form-group has-icon direction-ltr">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">phone_iphone</mat-icon>

                            </span>

                            <input class="mt-4 w-100 form-control" formControlName="strMobile" appPhoneNumberValidation
                                [class.is-invalid]="signUpModel.get('strMobile')?.touched && signUpModel.get('strMobile')?.invalid || (signUpModel.get('strMobile')?.touched && signUpModel.get('strMobile')?.value?.length !== valid_MaxLength) || signUpModel.get('strMobile')?.hasError('mobilePhoneNumberWrong')"
                                [placeholder]="valid_PlaceHolder | faNum" inputmode="numeric"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')" [maxlength]="valid_MaxLength"
                                type="text" />

                        </div>
                        <small *ngIf="signUpModel.get('strMobile')?.touched && signUpModel.get('strMobile')?.hasError('required')" class="text-danger d-block text-end mt-1" style="font-size: 12px;">
                            شماره موبایل الزامی است
                        </small>
                        <small *ngIf="signUpModel.get('strMobile')?.touched && !signUpModel.get('strMobile')?.hasError('required') && !signUpModel.get('strMobile')?.hasError('mobilePhoneNumberWrong') && signUpModel.get('strMobile')?.value?.length !== valid_MaxLength" class="text-danger d-block text-end mt-1" style="font-size: 12px;">
                            شماره موبایل باید {{ valid_MaxLength | faNum }} رقم باشد
                        </small>
                        <small *ngIf="signUpModel.get('strMobile')?.touched && signUpModel.get('strMobile')?.hasError('mobilePhoneNumberWrong')" class="text-danger d-block text-end mt-1" style="font-size: 12px;">
                            شماره موبایل باید با 09 شروع شود
                        </small>

                    </ng-container>

                    <!-- قوانین در حالت لاگین -->

                    <div *ngIf="isLoginMode" class="d-flex mt-2 rules-wrapper align-items-center flex-wrap">

                        <input type="checkbox" formControlName="rules" (change)="checkRules($event)" required>

                        <label class="px-1">

                            <a class="pointer" (click)="openAdd()">قوانین و مقررات</a> را مطالعه کردم و موافقم

                        </label>
                    </div>
                    <small *ngIf="isLoginMode && signUpModel.get('rules')?.touched && !rulesRead" class="text-danger d-block text-end mt-1" style="font-size: 12px;">
                        پذیرش قوانین الزامی است
                    </small>

                    <!-- فرم ثبت‌ نام -->

                    <ng-container *ngIf="isSignUpMode">

                        <ng-container *ngIf="signUpModel.get('tiFloats')?.value > 0">

                            <div class="alert alert-info">
    
                                <p class="mb-0"> این مالک {{ signUpModel.get('tiFloats')?.value | faNum}} شناور به نام خود دارد. </p>
    
                            </div>

                        </ng-container>

                        <!-- نام -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">person</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strName" placeholder="* نام"
                                [class.is-invalid]="isFieldInvalid('strName')">

                        </div>
                        <small *ngIf="isFieldInvalid('strName')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            نام الزامی است
                        </small>

                        <!-- نام خانوادگی -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">person</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strFamily"
                                placeholder="* نام خانوادگی"
                                [class.is-invalid]="isFieldInvalid('strFamily')">

                        </div>
                        <small *ngIf="isFieldInvalid('strFamily')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            نام خانوادگی الزامی است
                        </small>

                        <!-- کدملی مالک شناور -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">badge</mat-icon>

                            </span>

                            <input class="my-3 w-100 form-control" formControlName="strID"
                                [ngClass]="signUpModel.get('strID').value ? 'direction-ltr' : ''"
                                [class.is-invalid]="isFieldInvalid('strID')"
                                placeholder="* کدملی مالک شناور" inputmode="numeric" maxlength="10"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')" />

                        </div>
                        <small *ngIf="isFieldInvalid('strID')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            کد ملی الزامی است
                        </small>
                        <small *ngIf="signUpModel.get('strID')?.touched && !isFieldInvalid('strID') && signUpModel.get('strID')?.value?.length !== 10" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            کد ملی باید ۱۰ رقم باشد
                        </small>

                        <!-- استان -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">apartment</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="strStateCode" (change)="getCity($event.target.value)"
                                [class.is-invalid]="isFieldInvalid('strStateCode')">

                                <option value=""> * استان</option>

                                <option *ngFor="let s of lst_States" [value]="s.strState">{{ s.strStateName }}</option>

                            </select>

                        </div>
                        <small *ngIf="isFieldInvalid('strStateCode')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            انتخاب استان الزامی است
                        </small>

                        <!-- شهر -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">apartment</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="strCity"
                                [class.is-invalid]="isFieldInvalid('strCity')">

                                <option value="">* شهر</option>

                                <option *ngFor="let c of list_City" [value]="c.strCity.trim()">

                                    {{ c.strCityName }}

                                </option>

                            </select>

                        </div>
                        <small *ngIf="isFieldInvalid('strCity')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            انتخاب شهر الزامی است
                        </small>

                        <!-- نوع شناور  -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">directions_boat</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="tiFloatingType"
                                [class.is-invalid]="isFieldInvalid('tiFloatingType')">

                                <option value="-1"> * نوع شناور </option>

                                <option *ngFor="let f of lst_FloatingType" [value]="f.tiFloatingType">

                                    {{ f.strFloatingType }}

                                </option>

                            </select>

                        </div>
                        <small *ngIf="isFieldInvalid('tiFloatingType') || (signUpModel.get('tiFloatingType')?.touched && signUpModel.get('tiFloatingType')?.value === '-1')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            نوع شناور الزامی است
                        </small>

                        <!-- توان موتور شناور  -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">electric_bolt</mat-icon>

                            </span>

                            <input class="w-100 mb-3 form-control" placeholder="* توان موتور شناور"
                                [ngClass]="signUpModel.get('iPower').value ? 'direction-ltr' : ''"
                                [class.is-invalid]="isFieldInvalid('iPower')"
                                formControlName="iPower" inputmode="numeric"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')">

                        </div>
                        <small *ngIf="isFieldInvalid('iPower')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            توان موتور الزامی است
                        </small>

                        <!-- شماره موتور  -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">numbers</mat-icon>

                            </span>

                            <input class="w-100 mb-3 form-control" placeholder=" شماره موتور"
                                [ngClass]="signUpModel.get('strVIN').value ? 'direction-ltr' : ''"
                                [class.is-invalid]="isFieldInvalid('strVIN')"
                                formControlName="strVIN">

                        </div>
                        <small *ngIf="isFieldInvalid('strVIN')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            شماره موتور الزامی است
                        </small>

                        <!-- شناسه شناور  -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">card_membership</mat-icon>

                            </span>

                            <input class="w-100 mb-3 form-control " placeholder=" * شناسه شناور"
                                [ngClass]="signUpModel.get('strLicenseNo').value ? 'direction-ltr' : ''"
                                [class.is-invalid]="isFieldInvalid('strLicenseNo')"
                                formControlName="strLicenseNo">

                        </div>
                        <small *ngIf="isFieldInvalid('strLicenseNo')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            شناسه شناور الزامی است
                        </small>

                        <!-- آدرس محل نصب -->

                        <div class="form-group position-relative has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">add_location_alt</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strAddress"
                                [class.is-invalid]="isFieldInvalid('strAddress')"
                                [placeholder]='addressPlaceHolder'>

                            <button class="btn btn-warning rounded" (click)="show_Map()">

                                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                            </button>

                            <custom-map *ngIf="openMap" [strValue]="mdl_Map.get('strAddress')?.value"
                                [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
                                (mdl_Submit)="submitMap($event)">

                            </custom-map>

                        </div>
                        <small *ngIf="isFieldInvalid('strAddress')" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            آدرس محل نصب الزامی است
                        </small>

                        <!-- توضیحات -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">description</mat-icon>

                            </span>

                            <textarea style="height: 100px;" type="text" class="w-100 mb-3 form-control"
                                placeholder="مثلا: بهترین ساعت حضور کارشناس نصب و توضیحات تکمیلی..."
                                formControlName="strComment"></textarea>

                        </div>

                        <!-- برق DC  -->

                        <div class="form-check form-switch my-3 d-flex align-items-center col-12 py-2">

                            <input class="form-check-input m-0" type="checkbox" id="bHas12DC"
                                formControlName="bHas12DC">

                            <label class="form-check-label pointer text-muted me-2" for="bHas12DC"> {{ 'شناور دارای برق 12 یا24 ولت DC می باشد' | faNum}} </label>

                        </div>

                        <!-- قوانین ثبت‌ نام -->

                        <div class="d-flex align-items-center">

                            <input type="checkbox" formControlName="rules" (change)="checkRules($event)" required>

                            <label class="px-1">

                                <a class="pointer" style="text-decoration: underline;" (click)="openAdd()">قوانین و مقررات</a> را مطالعه کردم و موافقم

                            </label>

                        </div>
                        <small *ngIf="signUpModel.get('rules')?.touched && !rulesRead" class="text-danger d-block text-end mt-1" style="font-size: 12px;">
                            پذیرش قوانین الزامی است
                        </small>

                    </ng-container>

                    <!-- فرم OTP -->

                    <ng-container *ngIf="isOtpMode">

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">sms</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strActivateCode" inputmode="numeric"
                                placeholder="کد تایید" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                maxlength="4" type="text" />

                        </div>
                        <small *ngIf="signUpModel.get('strActivateCode')?.touched && (signUpModel.get('strActivateCode')?.value?.length || 0) < 4" class="text-danger d-block text-end mt-n2 mb-2" style="font-size: 12px;">
                            کد تایید ۴ رقمی الزامی است
                        </small>

                    </ng-container>

                </form>

                <div class="modal-footer d-flex flex-row-reverse justify-content-end">

                    <button type="button" class="btn btn-primary px-4" (click)="onSubmit()">

                        {{ (!bSendOtp && !bLoginMode) ? 'ثبت نام' : 'تایید' }}

                    </button>

                    <button *ngIf="bSendOtp && !bLoginMode" type="button" class="btn btn-outline-dark px-4"
                        (click)="sendAgain_Otp()" [disabled]="otpTimer !== 0">

                        ارسال مجدد کد

                        <span *ngIf="otpTimer !== 0" class="me-1">

                            {{ otpTimer | faNum }}

                        </span>

                    </button>

                </div>

            </div>

            <ng-container *ngIf="isLoginMode">

                <div class="alert alert-secondary my-0 mt-2">
                    <p class="my-0 p-0">

                        <small class="fw-bold">
                            {{' در صورت بروز مشکل یا نیاز به راهنمایی، لطفاً با شماره‌های زیر تماس حاصل فرمایید:
                            09177563345 - 2-77273160-021' | faNum
                            }}
                        </small>
                    </p>
                </div>

            </ng-container>

        </div>

    </div>

</main>
